
import React, { useState } from "react";
import * as yup from 'yup';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../styles/forgotpassword.css';
// import AuthLeftPanel from '../components/AuthLeftPanel';
import VerifyAccountBox from '../components/VerifyAccountBox';
import { useDispatch } from 'react-redux';
import { forgotPassword } from '../features/authSlice';
import CKALogo from '../assets/images/CKA Birla_Logo.svg';
import BirlanuLogo from '../assets/images/birlanu_water_tank_logo.svg';
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [showVerify, setShowVerify] = useState(false);
  const dispatch = useDispatch();

  const schema = yup.object().shape({
    email: yup.string().email('Enter a valid email address').required('Email is required'),
  });

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!validateEmail(email)) {
      setErrors({ email: 'Please enter a valid email address' });
      setLoading(false);
      return;
    }
    try {
      await schema.validate({ email }, { abortEarly: false });
      setErrors({});
      const resultAction = await dispatch(forgotPassword({ email }));
      setLoading(false);
      if (forgotPassword.fulfilled.match(resultAction)) {
        setMessage('If this email is registered, you will receive reset instructions.');
        toast.success('Otp send to email');
        setShowVerify(true);
      } else {
        toast.error(resultAction.payload || 'Failed to send reset instructions');
      }
    } catch (validationError) {
      const newErrors = {};
      if (validationError.inner) {
        validationError.inner.forEach((err) => {
          newErrors[err.path] = err.message;
        });
      }
      setErrors(newErrors);
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div>
        <div className="login-logo">
          <img src={BirlanuLogo} alt="Birlanu Water Tank Logo" />
        </div>
        {showVerify ? (
          <VerifyAccountBox email={email} onVerify={code => { }} onResend={() => { }} />
        ) : (
          <div className="login-form">
            <h1>Forgot Password</h1>
            <h3>No worries! Enter your email address below and we will send you a code to reset password.</h3>
            <form onSubmit={handleSubmit} className="form-info">
              <label htmlFor="email" className="form-label">E-mail</label>
              <input
                type="email"
                id="email"
                className="form-input mb-0"
                placeholder="Enter your email"
                style={{ marginBottom: errors.email ? '4px' : '', borderColor: errors.email ? '#D7184D' : '' }}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (errors.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.target.value)) {
                    setErrors({ ...errors, email: undefined });
                  }
                }}
              />
              {errors.email && (
                <span className="login-input-error">{errors.email}</span>
              )}
              <button type="submit" className="login-btn" disabled={loading}>
                {loading ? 'Sending...' : 'Send OTP'}
              </button>
              {message && <div className="forgot-message">{message}</div>}

            </form>
          </div>
        )}
      </div>
      <div className="footer-section">
        <img src={CKALogo} alt="CKA Birla Logo" />
        <div className="footer-links">
          <Link to="/terms-of-service" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link>
          <span>&nbsp;|&nbsp;</span>
          <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>
        </div>
      </div>
    </div>
  )
}

export default ForgotPassword;
